import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, StrictEffect, takeLatest } from "redux-saga/effects";

import { FeatureType } from "@/jenesys-types/data/enums";
import { extractError } from "@/jenesys-types/errors";

import { performFeatureAction } from "@/services/api";

import {
  loadDocumentImageURL,
  loadDocumentImageURLFailure,
  LoadDocumentImageURLPayload,
  loadDocumentImageURLSuccess
} from "./documentPreview";

// Saga to handle loading (and caching) document image URLs
function* loadDocumentImageURLSaga(
  action: PayloadAction<LoadDocumentImageURLPayload>
): Generator<StrictEffect, void, any> {
  const { companyId, documentId } = action.payload;

  try {
    const response: { url: string } = yield call(
      performFeatureAction,
      FeatureType.Bookkeeping,
      "loadDocumentImageURL",
      { companyId, documentId }
    );
    // Store the url in the cache under the transactionId
    yield put(
      loadDocumentImageURLSuccess({ id: documentId, url: response.url })
    );
  } catch (error) {
    yield put(loadDocumentImageURLFailure(extractError(error)));
  }
}

export default function* documentPreviewSaga() {
  yield takeLatest(loadDocumentImageURL.type, loadDocumentImageURLSaga);
}
